const MOL = {
  ADD_INIT: 'MOL_ADD_INIT',
  ADD_DONE: 'MOL_ADD_DONE',
  ADD_FAIL: 'MOL_ADD_FAIL',
  CONVERT_DONE: 'MOL_CONVERT_DONE',
  CONVERT_FAIL: 'MOL_CONVERT_FAIL',
};

const FILE = {
  ADD_INIT: 'FILE_ADD_INIT',
  ADD_DONE: 'FILE_ADD_DONE',
  ADD_FAIL: 'FILE_ADD_FAIL',
  CONVERT_DONE: 'FILE_CONVERT_DONE',
  CONVERT_FAIL: 'FILE_CONVERT_FAIL',
  SAVE_INIT: 'FILE_SAVE_INIT',
  SAVE_DONE: 'FILE_SAVE_DONE',
  SAVE_FAIL: 'FILE_SAVE_FAIL',
  REFRESH_INIT: 'FILE_REFRESH_INIT',
};

const NOTICE = {
  MANUAL_CLEAR: 'NOTICE_MANUAL_CLEAR',
};

const PREDICT = {
  PREDICT_INIT: 'PREDICT_PREDICT_INIT',
  PREDICT_DONE: 'PREDICT_PREDICT_DONE',
  PREDICT_FAIL: 'PREDICT_PREDICT_FAIL',
  PREDICT_TO_WRITE_INIT: 'PREDICT_PREDICT_TO_WRITE_INIT',
  PREDICT_TO_WRITE_DONE: 'PREDICT_PREDICT_TO_WRITE_DONE',
  ADD_PRED_JSON_INIT: 'PREDICT_ADD_PRED_JSON_INIT',
};

const FORM = {
  SUBMIT: 'FORM_SUBMIT',
};

const DESC = {
  UPDATE: 'DESC_UPDATE',
};

const JCAMP = {
  ADD_OTHERS_INIT: 'JCAMP_ADD_OTHERS_INIT',
  ADD_OTHERS_RDC: 'JCAMP_ADD_OTHERS_RDC',
};

export {
  MOL,
  FILE,
  NOTICE,
  PREDICT,
  FORM,
  DESC,
  JCAMP,
};
